<template>
    <span v-if="css" class="cms-custom-css">
    </span>
</template>

<script>
// cms-custom-css #hot-reload-debug

/*
To inject custom style to blocks and components
 */
export default {
    name: `cms-custom-css`,
    props: {
        itemId: {type: String},
        boundItem: {type: Object},
        css: {type: String}
    },
    data() {
        return {
            cssElement: null
        }
    },
    mounted() {
        this.applyCustomStyle();
    },
    beforeDestroy() {
        this.removeCustomStyle();
    },
    methods: {
        async applyCustomStyle() {
            if (!this.css) {
                this.removeCustomStyle();
                return;
            }
            if (!this.cssElement) {
                this.cssElement = document.createElement(`style`);
                this.cssElement.type = `text/css`;
                this.$el.appendChild(this.cssElement);
            }

            let css = this.css;

            if (this.boundItem && (css?.indexOf(`{{`) >= 0 || css?.indexOf(`{%`) >= 0)) {
                css = await window.liquid.parseAndRender(css, {
                    item: this.boundItem
                });
            }

            this.cssElement.innerHTML = `#${this.itemId} {${css}}`;
        },
        removeCustomStyle() {
            if (this.cssElement && this.cssElement.parentNode) {
                this.cssElement.parentNode.removeChild(this.cssElement);
            }
        }
    },
    watch: {
        css: {
            immediate: true,
            handler() {
                this.$nextTick(() => {
                    this.applyCustomStyle();
                });
            }
        }
    }
}
</script>

<style>
</style>
